export const pvbill = {
    PvBillClass: {
        url: "Finanzierung/pv",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_PvBillClass_pvbillReducer'
    }
};